module.exports = __webpack_public_path__ + "media/hyper/images/projects/project-2-c38211904ba3ce03af3ca248d6971f18.jpg";